module.exports = __webpack_public_path__ + "media/images/city_img/b_1-15497575759702f679de26f822b6fd07.jpg";